import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { paths } from '@/app/paths';
import { useSideNavStyle } from '../useSideNavStyle';

export const AdminSideNavBrand = () => {
	const { sideNavItemColor } = useSideNavStyle();

	return (
		<Typography
			component={Link}
			to={paths.admin}
			sx={{
				color: sideNavItemColor,
				fontWeight: 700,
				fontSize: '1rem',
				lineHeight: '22px',
				whiteSpace: 'nowrap',
				textDecoration: 'none',
			}}
		>
			FolioAdmin
		</Typography>
	);
};
